import React, { Component } from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import axios from 'axios';
import Home from './home/Home';
import AboutUs from './aboutus/AboutUs';
import WhatWeDo from './aboutus/WhatWeDo';
import ContactUs from './contact/ContactUs';
import OurTeam from './ourteam/OurTeam';
import PracticeAreasApp from './practiceareas/PracticeAreasApp';
import PrivacyPolicy from './privacypolicy/PrivacyPolicy';
import TermsCondition from './termscondition/TermsCondition';
import OurServices from './ourservices/OurServices';
import LoginApp from './login/LoginApp';
import FConsultationApp from './freeConsultation/FConsultationApp';
import SConsultationApp from './scheduleConsultation/SConsultationApp';
import ResetPasswordApp from './resetpassword/ResetPasswordApp';
import AdminApp from './admin/AdminApp';
import UserApp from './user/UserApp';
import ComingSoon from './commonFiles/ComingSoon';
import Disclaimer from './commonFiles/Disclaimer';
import Videos from './insights/Videos';
import Articles from './insights/Articles';
import BlogView from './insights/BlogView';
import ProBonoLegalHelp from './insights/ProBonoLegalHelp';
import CollaborationsApp from './collaborations/CollaborationsApp';
import NewAndUpdatesApp from './new_updates/NewAndUpdatesApp';
import $ from "jquery";

class BLIFrame extends Component {
  constructor() {
    super();
    this.state = {
      disclaimer_view:'',
    };
  }

  componentDidMount() {
    this.check_accept_disclaimer();
  }

    check_accept_disclaimer(){
      let cutThis = this;
      var web_token = $('#web_token').val();
           var body = new FormData();
           body.append('web_token',web_token);
           body.append('function','check_accept_disclaimer');
           var url      = '';
           if(window.location.host ==="localhost:3000"){
             url = "http://localhost/bylawsindia/php/home_url.php";
           }else{
             url = "/php/home_url.php";
           }
           axios({
                method: 'POST',
                url: url,
                data: body
            })
            .then(function (res) {
              var data = res.data;
               if(data==0){
                 var disclaimer_view = <Disclaimer/>;
                 cutThis.setState({disclaimer_view});
                 setTimeout(function (){window.model_show();},100);
               }else{
                 var disclaimer_view = '';
                 cutThis.setState({disclaimer_view});
               }
            })
            .catch(function (error) {
                console.log(error);
            });


    }


  render() {

    return (
      <Router>
        <Switch>
        {/*<Route exact  path="/"                      component={ComingSoon}          key="ComingSoon"/>*/}
        <Route exact  path="/"                      component={Home}                key="Home"/>
        <Route exact  path="/aboutus"               component={AboutUs}             key="AboutUs"/>
        <Route exact  path="/what_we_do"            component={WhatWeDo}            key="WhatWeDo"/>
        <Route exact  path="/contact"               component={ContactUs}           key="ContactUs"/>
        <Route exact  path="/ourteam"               component={OurTeam}             key="OurTeam"/>
        <Route exact  path="/practice"              component={PracticeAreasApp}    key="PracticeAreasApp"/>
        <Route exact  path="/privacy"               component={PrivacyPolicy}       key="PrivacyPolicy"/>
        <Route exact  path="/terms"                 component={TermsCondition}      key="TermsCondition"/>
        <Route exact  path="/services"              component={OurServices}         key="OurServices"/>
        <Route exact  path="/login"                 component={LoginApp}            key="LoginApp"/>
        <Route exact  path="/freeConsultation"      component={FConsultationApp}    key="FConsultationApp"/>
        <Route exact  path="/scheduleConsultation"  component={SConsultationApp}    key="SConsultationApp"/>
        <Route exact  path="/reset"                 component={ResetPasswordApp}    key="ResetPasswordApp"/>
        <Route exact  path="/admin"                 component={AdminApp}            key="AdminApp"/>
        <Route exact  path="/user"                  component={UserApp}             key="UserApp"/>
        <Route exact  path="/videos"                component={ComingSoon}          key="Videos"/>
        <Route exact  path="/articles"              component={ComingSoon}          key="Articles"/>
        <Route exact  path="/blogs"                 component={ComingSoon}          key="BlogView"/>
        <Route exact  path="/collaborations"        component={CollaborationsApp}   key="CollaborationsApp"/>
        <Route exact  path="/pro_bono_begal_help"   component={ProBonoLegalHelp}    key="ProBonoLegalHelp"/>
        <Route exact  path="/new_updates"           component={NewAndUpdatesApp}    key="NewAndUpdatesApp"/>
        </Switch>
        {this.state.disclaimer_view}
        </Router>

    );
  }
}

export default BLIFrame;
